module.exports = __webpack_public_path__ + "img/DE00430.60086278.png";